import React from 'react';
import { Bot, TrendingUp, DollarSign, Clock, Settings } from 'lucide-react';
import Disclaimer from '../components/Disclaimer';

const AutomatedTrader = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center">
            <Bot className="h-8 w-8 mr-3 text-blue-600" />
            Automated Stock Trader
          </h1>
          <p className="text-gray-600">Automated trading system - Coming soon</p>
        </div>
        <Disclaimer variant="investment" />

        {/* Coming Soon Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
          <div className="max-w-md mx-auto">
            <div className="mb-6">
              <div className="mx-auto w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <Bot className="h-12 w-12 text-blue-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Coming Soon</h2>
              <p className="text-gray-600">
                The automated trading system is currently under development.
              </p>
            </div>

            {/* Feature Preview */}
            <div className="mt-8 space-y-4 text-left">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <TrendingUp className="h-5 w-5 text-blue-600 mt-0.5" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-gray-900">Automated Signal Execution</h3>
                  <p className="text-sm text-gray-600">Execute trades based on analysis signals automatically</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <DollarSign className="h-5 w-5 text-blue-600 mt-0.5" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-gray-900">Risk Management</h3>
                  <p className="text-sm text-gray-600">Built-in stop-loss and position sizing controls</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <Clock className="h-5 w-5 text-blue-600 mt-0.5" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-gray-900">24/7 Monitoring</h3>
                  <p className="text-sm text-gray-600">Continuous market monitoring and trade execution</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <Settings className="h-5 w-5 text-blue-600 mt-0.5" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-gray-900">Customizable Strategies</h3>
                  <p className="text-sm text-gray-600">Configure trading rules and parameters to match your strategy</p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                This feature will be available in a future update. Check back soon!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomatedTrader;


